import React from 'react';
import { FaSolarPanel, FaWater, FaRecycle, FaBolt, FaLightbulb } from 'react-icons/fa';
import './TipsTricks.css';

const tips = [
  {
    icon: <FaSolarPanel />,
    title: "Maximize Solar Efficiency",
    description: "Regularly clean your solar panels to remove dust and debris. This simple maintenance can boost your energy output by up to 25% in dusty environments like Madurai."
  },
  {
    icon: <FaWater />,
    title: "Optimizing STP Performance",
    description: "Consistent monitoring of MLSS levels and dissolved oxygen is key. Proper aeration ensures that the biological treatment process remains efficient and compliant."
  },
  {
    icon: <FaRecycle />,
    title: "Biogas Feed Management",
    description: "For consistent gas production, ensure a balanced mix of organic waste. Avoid introducing non-biodegradables and maintain a steady feeding schedule."
  },
  {
    icon: <FaBolt />,
    title: "Energy Efficiency Hacks",
    description: "An energy audit is the first step. Upgrading to LED lighting and optimizing motor loads can reduce your industrial energy consumption significantly."
  }
];

const TipsTricks = () => {
  return (
    <section id="tips" className="tips-section">
      <div className="container" data-aos="fade-up">
        <div className="section-header">
          <h2 className="tips-heading"><FaLightbulb /> Expert Tips & Tricks</h2>
          <p className="tips-sub">Sustainable practices for a greener future</p>
        </div>
        <div className="tips-grid">
          {tips.map((tip, index) => (
            <div key={index} className="tip-card" data-aos="flip-left" data-aos-delay={index * 100}>
              <div className="tip-icon">{tip.icon}</div>
              <h3 className="tip-title">{tip.title}</h3>
              <p className="tip-description">{tip.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TipsTricks;
